import {  useState } from "react";
import { AuthContext } from "./AuthContext";


const AuthProvider= ({ children }) => {
  const [permissions, setPermissions] = useState([]);
  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("userInfo")) || {}
  );
  const [paymentMethods, setPaymentMethods] = useState([]);
  const getPaymentMethods = (paymentMethods) => {
    setPaymentMethods(paymentMethods);
  }
  const setThePermissions = (permissions) => {
    setPermissions(permissions);
  }
  const login = (userInfo) => {
    setUserInfo(userInfo);
    localStorage.setItem("userInfo", JSON.stringify(userInfo));
  };
  const logout = () => {
    setUserInfo({});
    localStorage.removeItem("userInfo");
  };
  
  const isAuthenticated = !!userInfo?.token;
  return (
    <AuthContext.Provider
      value={{
        userInfo,
        isAuthenticated,
        login,
        logout,
        permissions,
        setThePermissions,
        paymentMethods,
        getPaymentMethods,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
export default AuthProvider;
